///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { connect } from "react-redux";
import { findIndex, includes, isEmpty, orderBy } from "lodash";

import messages from "../../../helpers/messages";
import OutlinedInput from "../../form-controls/OutlinedInput";
import StatusCheckedIcon from "../../icons/StatusCheckedIcon";
import StatusUncheckedIcon from "../../icons/StatusUncheckedIcon";
import { updateLaneMatches } from "../../../slices/bidProcurementSlice";

export class SubmissionPricing extends Component {
  state = { rowsAccordion: [] };

  componentDidMount() {
    const {
      bidProcurement: { rowsSelected }
    } = this.props;
    const rowsAccordion = orderBy(rowsSelected, r => r, "asc").map(
      (row, index) => {
        if (index === 0) {
          return { row, open: true };
        } else {
          return { row, open: false };
        }
      }
    );
    this.setState({ rowsAccordion });
  }

  updateLaneMatch = (truckloadLaneId, carrierId, field, value) => {
    const { dispatch } = this.props;
    dispatch(
      updateLaneMatches({
        truckloadLaneIds: [truckloadLaneId],
        carrierId,
        field,
        value
      })
    );
  };

  handleAccordion = (row, open) => {
    let rowsAccordion = this.state.rowsAccordion;
    let rowAccordionIndex = findIndex(rowsAccordion, x => x.row === row);
    rowsAccordion[rowAccordionIndex] = {
      ...rowsAccordion[rowAccordionIndex],
      open: !open
    };
    this.setState({ rowsAccordion });
  };

  render() {
    const {
      bidProcurement: {
        capacityMatchCarriers: { laneMatches },
        capacityMatchLaneSummary: { capacityMatches },
        rowsSelected
      }
    } = this.props;

    const laneInfo = capacityMatches?.filter(x =>
      includes(rowsSelected, x.truckloadLaneId)
    );

    return (
      <div className="mt-6 pt-12" data-testid="submission-pricing">
        <span className="font-size-18 weight--semibold pl-24">
          {messages.addSubmissionPricing.defaultMessage}
        </span>
        <p className="pt-8 pl-24">
          {
            messages.addPricingDetailsForTheCarriersSelectedUnderEachLane
              .defaultMessage
          }
        </p>
        <div className="mt-20 grid section-grid submission-pricing">
          <div data-testid="header" className="pl-16">
            <div className="grid__cell one-tenth font-size-14 weight--semibold">
              {messages.status.defaultMessage}
            </div>
            <div className="grid__cell one-fifth font-size-14 weight--semibold">
              {messages.laneId.defaultMessage}
            </div>
            <div className="grid__cell one-quarter font-size-14 weight--semibold">
              {messages.origin.defaultMessage}
            </div>
            <div className="grid__cell one-quarter font-size-14 weight--semibold">
              {messages.destination.defaultMessage}
            </div>
            <div className="grid__cell one-fifth font-size-14 weight--semibold">
              {messages.volume.defaultMessage}
            </div>
          </div>
          {laneInfo.map((lane, index) => {
            const matchesOnALane = laneMatches.filter(
              x => x.truckloadLaneId === lane.truckloadLaneId
            );
            const isAnyRateEmpty = matchesOnALane?.some(x =>
              isEmpty(x.carrierRate)
            );
            const rowAccordion = this.state.rowsAccordion.find(
              x => x.row === lane.truckloadLaneId
            );

            return (
              <div
                key={`lane-info-${index}`}
                className="body"
                data-testid="row"
              >
                <div
                  data-testid="lane-info-row"
                  className="pl-16"
                  onClick={() =>
                    this.handleAccordion(
                      lane.truckloadLaneId,
                      rowAccordion?.open
                    )
                  }
                >
                  <div className="grid__cell one-tenth">
                    {isAnyRateEmpty ? (
                      <StatusUncheckedIcon
                        height={20}
                        width={20}
                        className="align-middle"
                        data-testid="status-unchecked-icon"
                      />
                    ) : (
                      <StatusCheckedIcon
                        height={20}
                        width={20}
                        className="align-middle"
                        data-testid="status-checked-icon"
                      />
                    )}
                  </div>
                  <div className="grid__cell one-fifth truncate">
                    {lane.shipperLaneId}
                  </div>
                  <div className="grid__cell one-quarter truncate">{`${
                    lane.originCity
                  }, ${lane.originState} ${
                    lane.originPostalCode ? lane.originPostalCode : ""
                  }`}</div>
                  <div className="grid__cell one-quarter truncate">{`${
                    lane.destinationCity
                  }, ${lane.destinationState} ${
                    lane.destinationPostalCode ? lane.destinationPostalCode : ""
                  }`}</div>
                  <div className="grid__cell one-fifth truncate">
                    {lane.volume}
                  </div>
                </div>
                <div
                  data-testid="lane-match-accordion"
                  className={`accordion ${rowAccordion?.open ? "" : "hidden"}`}
                >
                  {matchesOnALane?.map((laneMatch, index) => {
                    return (
                      <div
                        key={`lane-match-${index}`}
                        className="pl-16"
                        data-testid="lane-match"
                      >
                        <div
                          className="grid__cell one-half weight--semibold truncate mt-16"
                          title={`${laneMatch.carrierName} (${laneMatch.carrierCode})`}
                        >
                          {laneMatch.carrierName} ({laneMatch.carrierCode})
                        </div>
                        <div className="grid__cell one-quarter carriers-cell align-super">
                          {laneMatch.incumbent
                            ? messages.incumbent.defaultMessage
                            : null}
                        </div>
                        <div
                          className="grid__cell one-quarter"
                          data-testid="carrierRate"
                        >
                          <OutlinedInput
                            id="carrierRate"
                            type="text"
                            value={laneMatch?.carrierRate || ""}
                            pattern="^\d{0,8}(|\.\d{0,2})$"
                            unit="$"
                            isUnitPositionLeft={true}
                            onChange={event =>
                              !event.target.validity.patternMismatch &&
                              this.updateLaneMatch(
                                lane.truckloadLaneId,
                                laneMatch.carrierId,
                                "carrierRate",
                                event.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  bidProcurement: state.bidProcurement
});

export default connect(mapStateToProps)(SubmissionPricing);
